import { Spacer } from "components/general/Spacer/Spacer";
import { Token } from "store/global/TokenEnum";

export const SamePartyTooltipContent = ({
  currentSymbol,
  otherSymbol,
  isTaker,
}: {
  currentSymbol: Token;
  otherSymbol: Token;
  isTaker: boolean;
}) => {
  if (isTaker) {
    return (
      <>
        Paying {currentSymbol} is unavailable when also paying {otherSymbol}.
        <Spacer height={6} />
        If you wish to pay {currentSymbol}, then please remove {otherSymbol}.
      </>
    );
  }

  // Maker side
  return (
    <>
      Receiving {currentSymbol} is unavailable when also receiving {otherSymbol}.
      <Spacer height={6} />
      If you wish to receive {currentSymbol}, then please remove {otherSymbol}.
    </>
  );
};

export const OpposingPartyNon121TooltipContent = ({
  toPay,
  toReceive,
  isTaker,
}: {
  toPay: Token;
  toReceive: Token;
  isTaker: boolean;
}) => {
  if (isTaker) {
    return (
      <>
        Paying {toPay} is unavailable when also receiving {toReceive}.
        <Spacer height={6} />
        If you wish to pay {toPay}, then please select a different token other than {toReceive} to
        receive.
      </>
    );
  }
  return (
    <>
      Receiving {toReceive} is unavailable when also paying {toPay}.
      <Spacer height={6} />
      If you wish to receive {toReceive}, then please select a different token other than {toPay} to
      pay.
    </>
  );
};

export const AllOtherTokensDisabledHoverContent = ({
  nativeToken,
  wrappedToken,
  isTaker,
}: {
  nativeToken: Token;
  wrappedToken: Token;
  isTaker: boolean;
}) => {
  return (
    <>
      {isTaker ? "Paying" : "Receiving"} additional tokens is unavailable when paying and receiving
      between {nativeToken} and {wrappedToken}.
      <Spacer height={6} />
      If you wish to {isTaker ? "pay" : "receive"} additional tokens then please remove either{" "}
      {nativeToken} or {wrappedToken}.
    </>
  );
};
